import React from "react";
import { useNavigate } from "react-router";
import { RoutesPaths } from "../Router/constant";

export default function OtherQuotationAdvisor({
  payouts,
  isAdvisorUser,
  disableLinks = false,
}) {
  const navigate = useNavigate();
  return (
    <div className="caAnalyticsBar">
      <div className="caAnalyticsBarHeader">
        <h3 className="m-0">Deals by this advisor</h3>
      </div>

      <div className="advisoraboutOuter">
        {payouts?.length > 0 ? (
          payouts?.slice(0, 5)?.map((payout, index) => (
            <div
              onClick={() => {
                if (disableLinks) return;

                navigate(
                  RoutesPaths.QUOTATION_PUBLIC.replace(
                    ":slug",
                    payout?.plan?.slug,
                  ),
                );
              }}
              className="campaignLink"
              key={index}
            >
              <p className="m-0">
                {payout?.plan?.name} - {payout?.plan?.createdAt}
              </p>
            </div>
          ))
        ) : (
          <div className="campaignNotFound">
            {isAdvisorUser ? (
              <img src="/assets/img/noOtherQuotation.svg" alt="" />
            ) : (
              <img src="/assets/img/nocompanyQuotation.svg" alt="" />
            )}
            <h6 className="m-0">No quotations available</h6>
            <p className="m-0">
              No quotations have been created yet. They will appear here once available.
            </p>
          </div>
        )}
      </div>
    </div>
  );
}
